import { render, staticRenderFns } from "./applyTable.vue?vue&type=template&id=399a4ffa&scoped=true"
import script from "./applyTable.vue?vue&type=script&lang=js"
export * from "./applyTable.vue?vue&type=script&lang=js"
import style0 from "./applyTable.vue?vue&type=style&index=0&id=399a4ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a4ffa",
  null
  
)

export default component.exports